export default "/kiban/_next/static/images/03_4L_1-2-1_withBH_staggered-9dfac6074192746a68170236c06f3c52.png";